import actions from "./actions";
import sentry from "../utils/sentry";
import { refreshEntries } from "./historyActions";

export function deleteEntry(entry) {
  return (dispatch, getState) => {
    dispatch(deletingEntry());

    getState().api.deleteTimeEntries(entry.id)
      .then((response) => {
        if (response.status === 204) {
          return response.text();
        }
        throw new Error("Could not delete entry");
      })
      .then((result) => {
        dispatch({ type: actions.DELETE_ENTRY, entry });
        dispatch(refreshEntries());
      })
      .catch(error => sentry.logException(error))
      .finally(() => dispatch(deletedEntry()));
  };
}

export function submitEntry(entry) {
  return async (dispatch, getState) => {
    dispatch(submittingEntry());

    try {
      await getState().api.submitEntries(entry.id);
      await dispatch({ type: actions.SUBMIT_ENTRY, entry });
      await dispatch(refreshEntries());
    } catch (err) {
      sentry.logException(err);
      console.warn("Problem submitting entry");
      console.error(err);
    } finally {
      dispatch(submittedEntry());
    }
  };
}

export function submitEntryGroup() {
  return async (dispatch, getState) => {
    const promises = [];
    const submitted = [];

    const state = getState();

    const api = state.api;

    const entryGroup = state.entries.submitGroup;

    for (const id of Object.keys(entryGroup)) {
      if (entryGroup[id]) {
        const promise = api.submitEntries(id).then(() => {
          submitted.push(id);
        });

        promises.push(promise);
      }
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      sentry.logException(error);

      alert(`Error\n\n${error}`);

      return;
    }

    return await dispatch(refreshEntries());
  };
}

export function deletingEntry() {
  return { type: actions.DELETING_ENTRY };
}

export function deletedEntry() {
  return { type: actions.DELETED_ENTRY };
}

export function submittingEntry() {
  return { type: actions.SUBMITTING_ENTRY };
}

export function submittedEntry() {
  return { type: actions.SUBMITTED_ENTRY };
}

export function setEntry(entry) {
  return { type: actions.SET_ENTRY, payload: entry };
}



// WEBPACK FOOTER //
// ./app/actions/entryActions.js